import Api from "@/api/services/Api"

const route = '/auth'

export default {
    login: credentials => Api().post(`${route}/login`, credentials),
    roles: payload => Api().get(`profile?expand=roles`),
    change_profile: payload => Api().put(`profile`, payload),
    change_password: payload => Api().put(`profile/change-password`, payload)
}
